// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hdcc","top":"styles_top__1me2A","left":"styles_left__aVOLa","description":"styles_description__1mBrX"};